import React from "react";

export default function Try() {
  return <div>Try</div>;
}
